<div class="loading-modal">
  <mat-spinner></mat-spinner>
  <p>Carregando informações...</p>
</div>
